import $ from 'jquery';

$(() => {
    $('.js-switch-language').on("click", function(){
        $(this).toggleClass("open");
    });
});
